import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
  TextInput,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { BottomNavBar } from '../../../../components/BottomNavBar';
import { RootStackNavigationProp } from '../../../../types/navigation';


// Helper: format date as MM/DD/YYYY while typing
const formatDate = (text: string) => {
  const cleaned = text.replace(/\D/g, '');
  if (cleaned.length >= 8) {
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4, 8)}`;
  } else if (cleaned.length >= 4) {
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
  } else if (cleaned.length >= 2) {
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
  }
  return cleaned;
};

// Helper: format phone as (xxx) xxx-xxxx while typing
const formatPhoneNumber = (text: string) => {
  const cleaned = (text || '').replace(/\D/g, '');
  if (cleaned.length >= 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  } else if (cleaned.length >= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length >= 3) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  }
  return cleaned;
};

export const MortgageProviderInputScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();
  const [formData, setFormData] = useState({
    companyName: '',
    loanNumber: '',
    terminationDate: '',
    monthlyPaymentDate: '',
    monthlyPaymentAmount: '',
    lenderName: '',
    lenderWebsite: '',
    phone: '',
    email: '',
    userName: '',
    password: '',
    notes: '',
  });

  const handleSubmit = () => {
    navigation.navigate('MortgageProviderLockUnlock');
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Image
            source={require('../../../../assets/icons/back.png')}
            style={[styles.backIcon, { tintColor: '#fff' }]}
          />
        </TouchableOpacity>
      </View>

      <View style={styles.topSection}>
        <Image
          source={require('../../../../assets/icons/keyimage.png')}
          style={styles.backgroundKey}
        />
        <Image
          source={require('../../../../assets/logo.png')}
          style={styles.logo}
          resizeMode="contain"
        />
        <Text style={styles.title}>Add Mortgage Provider Info</Text>
      </View>

      <View style={styles.inputContainer}>
        <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollViewContent} keyboardShouldPersistTaps="handled" automaticallyAdjustKeyboardInsets={true}>
          <View style={styles.inputGroup}>
            <Text style={styles.label}>Lending Company Name</Text>
            <TextInput
              style={styles.input}
              value={formData.companyName}
              onChangeText={(text) => setFormData({ ...formData, companyName: text })}
              placeholder="Enter Company Name"
              placeholderTextColor="#A9A9A9"
            />
          </View>

          <View style={styles.inputGroup}>
            <Text style={styles.label}>Loan Number</Text>
            <TextInput
              style={styles.input}
              value={formData.loanNumber}
              onChangeText={(text) => setFormData({ ...formData, loanNumber: text })}
              placeholder="Enter Loan Number"
              placeholderTextColor="#A9A9A9"
            />
          </View>

          <View style={styles.inputGroup}>
            <Text style={styles.label}>Loan Termination Date</Text>
            <TextInput
              style={styles.input}
              value={formData.terminationDate}
              onChangeText={(text) => setFormData({ ...formData, terminationDate: formatDate(text) })}
              placeholder="MM/DD/YYYY"
              placeholderTextColor="#A9A9A9"
              keyboardType="number-pad"
              maxLength={10}
            />
          </View>
	   <View style={styles.inputGroup}>
            <Text style={styles.label}>Monthly Payment Due Date</Text>
            <TextInput
              style={styles.input}
              value={formData.monthlyPaymentDate}
              onChangeText={(text) => setFormData({ ...formData, monthlyPaymentDate: formatDate(text) })}
              placeholder="MM/DD/YYYY"
              placeholderTextColor="#A9A9A9"
              keyboardType="number-pad"
              maxLength={10}
            />
          </View>

	<View style={styles.inputGroup}>
            <Text style={styles.label}>Monthly Payment Amount</Text>
            <TextInput
              style={styles.input}
              value={formData.monthlyPaymentAmount}
              onChangeText={(text) => setFormData({ ...formData, monthlyPaymentAmount: text })}
              placeholder="Enter Payment Amount"
              placeholderTextColor="#A9A9A9"

            />
          </View>

	<View style={styles.inputGroup}>
            <Text style={styles.label}>Lender Contact (if applicable)</Text>
            <TextInput
              style={styles.input}
              value={formData.lenderName}
              onChangeText={(text) => setFormData({ ...formData, lenderName: text })}
              placeholder="Enter Contact"
              placeholderTextColor="#A9A9A9"

            />
          </View>

	<View style={styles.inputGroup}>
            <Text style={styles.label}>Lender Website</Text>
            <TextInput
              style={styles.input}
              value={formData.lenderWebsite}
              onChangeText={(text) => setFormData({ ...formData, lenderWebsite: text })}
              placeholder="Enter website address"
              placeholderTextColor="#A9A9A9"

            />
          </View>

	<View style={styles.inputGroup}>
            <Text style={styles.label}>Enter Username</Text>
            <TextInput
              style={styles.input}
              value={formData.userName}
              onChangeText={(text) => setFormData({ ...formData, userName: text })}
              placeholder="Enter Username"
              placeholderTextColor="#A9A9A9"

            />
          </View>

	<View style={styles.inputGroup}>
            <Text style={styles.label}>Enter Password</Text>
            <TextInput
              style={styles.input}
              value={formData.password}
              onChangeText={(text) => setFormData({ ...formData, password: text })}
              placeholder="Enter Password"
              placeholderTextColor="#A9A9A9"

            />
          </View>

          <View style={styles.inputGroup}>
            <Text style={styles.label}>Lender Email</Text>
            <TextInput
              style={styles.input}
              value={formData.email}
              onChangeText={(text) => setFormData({ ...formData, email: text })}
              placeholder="Enter Email"
              placeholderTextColor="#A9A9A9"
              keyboardType="email-address"
              autoCapitalize="words"
            />
          </View>

	  <View style={styles.inputGroup}>
            <Text style={styles.label}>Lender Phone Number</Text>
            <TextInput
              style={styles.input}
              value={formData.phone}
              onChangeText={(text) => setFormData({ ...formData, phone: formatPhoneNumber(text) })}
              placeholder="(xxx) xxx-xxxx"
              placeholderTextColor="#A9A9A9"
              keyboardType="number-pad"
              maxLength={14}
            />
          </View>

	 <View style={styles.inputGroup}>
            <Text style={styles.label}>Notes</Text>
            <TextInput
              style={styles.input}
              value={formData.notes}
              onChangeText={(text) => setFormData({ ...formData, notes: text })}
              placeholder="Enter Any Notes"
              placeholderTextColor="#A9A9A9"

            />
          </View>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={styles.submitButton}
              onPress={handleSubmit}
            >
              <Text style={styles.submitButtonText}>Submit</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.addMoreButton}
              onPress={() => {
                setFormData({
                  equipmentType: '',
                  companyName: '',
                  location: '',
                  accountNumber: '',
                  phone: '',
                  email: '',
                  notes: '',
                });
              }}
            >
              <Text style={styles.addMoreButtonText}>Add more medical equipment</Text>
            </TouchableOpacity>
          </View>
          <View style={styles.bottomPadding} />
        </ScrollView>
      </View>

      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
      flex: 1,
      backgroundColor: '#29BFC0',
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: ms(15),
      paddingTop: ms(70),
      position: 'relative',
    },
    backButton: {
      position: 'absolute',
      left: ms(50),
      padding: ms(15),
      paddingTop: ms(50),
      zIndex: 1,
    },
    backIcon: {
      width: s(32),
      height: s(32),
      tintColor: '#fff',
    },
    topSection: {
      alignItems: 'center',
      paddingVertical: ms(20),
    },
    backgroundKey: {
      position: 'absolute',
      width: '85%',
      height: '85%',
      opacity: 0.1,
    },
    logo: {
      width: s(125),
      height: s(125),
      marginBottom: ms(16),
    },
  title: {
    fontSize: ms(24, 0.3),
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: ms(8),
  },
  inputContainer: {
    flex: 1,
    backgroundColor: '#F3F6F8',
    borderTopLeftRadius: ms(20),
    borderTopRightRadius: ms(20),
    paddingTop: ms(20),
  },
  scrollView: {
    paddingHorizontal: ms(16),
  },
  scrollViewContent: {
    paddingBottom: ms(350),
  },
  inputGroup: {
    marginBottom: ms(16),
  },
  label: {
    fontSize: ms(16, 0.3),
    fontWeight: '600',
    color: '#6B7280',
    marginBottom: ms(8),
  },
  input: {
    backgroundColor: '#FFFFFF',
    borderRadius: ms(25),
    padding: ms(15),
    fontSize: ms(16, 0.3),
    color: '#1C2C4F',
    borderWidth: ms(1),
        borderColor: '#d8dbdd',
  },
  textArea: {
    height: s(100),
    textAlignVertical: 'top',
  },
  buttonContainer: {
    marginVertical: ms(20),
    gap: ms(15),
  },
  submitButton: {
    backgroundColor: '#29BFC0',
    borderRadius: ms(25),
    paddingVertical: ms(15),
    alignItems: 'center',
  },
  submitButtonText: {
    color: '#FFFFFF',
    fontSize: ms(18, 0.3),
    fontWeight: '600',
  },
  addMoreButton: {
    backgroundColor: '#FF9F64',
    borderRadius: ms(25),
    paddingVertical: ms(15),
    alignItems: 'center',
  },
  addMoreButtonText: {
    color: '#FFFFFF',
    fontSize: ms(18, 0.3),
    fontWeight: '600',
  },
  bottomPadding: {
    height: s(120),
  },
  dropdownIcon: {
    width: s(20),
    height: s(20),
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  modalContent: {
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: ms(20),
    borderTopRightRadius: ms(20),
    maxHeight: '80%',
    width: '100%',
    paddingBottom: ms(20),
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: ms(16),
    borderBottomWidth: ms(1),
    borderBottomColor: '#d8dbdd',
  },
  modalTitle: {
    fontSize: ms(18, 0.3),
    fontWeight: '600',
    color: '#1C2C4F',
  },
  modalCloseButton: {
    padding: ms(8),
  },
  modalCloseText: {
    fontSize: ms(20, 0.3),
    color: '#1C2C4F',
  },
  stateList: {
    padding: ms(16),
  },
  stateItem: {
    paddingVertical: ms(12),
    borderBottomWidth: ms(1),
    borderBottomColor: '#d8dbdd',
  },
  stateItemText: {
    fontSize: ms(16, 0.3),
    color: '#1C2C4F',
  },
});
